const activeVariantStatuses = new Set([
  'active-status',
  'closeout-status',
  'discontinued-status',
  'active',
  'closeout',
  'discontinued',
]);

const isVariantActive = (status) =>
  activeVariantStatuses.has(status?.toLowerCase() ?? '');

export default isVariantActive;
